module.exports = __webpack_public_path__ + "static/media/logo_java.6505cdab.png";